import React, { createContext, ReactNode, useMemo, useState } from "react";

interface AppContextType {
  isComparisionMode: boolean;
  setIsComparisionMode: (isComparisionMode: boolean) => void;
}

const defaultState: AppContextType = {
  isComparisionMode: false,
  setIsComparisionMode: () => {},
};

export const AppContext = createContext<AppContextType>(defaultState);

interface Props {
  children: ReactNode;
}

export const AppContextProvider: React.FC<Props> = ({ children }) => {
  const [isComparisionMode, setIsComparisionMode] = useState<boolean>(defaultState.isComparisionMode);

  const state = useMemo(() => ({ isComparisionMode, setIsComparisionMode }), [
    isComparisionMode,
    setIsComparisionMode,
  ]);

  return (
    <AppContext.Provider value={state}>
      {children}
    </AppContext.Provider>
  );
};
